import { Flex } from 'antd';

import { Schemas } from '@api-client/generated/types';

export const renderFiles = (
  person: Schemas.PersonResponseDto,
  type: string
) => {
  const files = person.files.filter((file) => file.type === type);

  if (!files.length) {
    return '-';
  }

  return (
    <Flex gap={4} vertical>
      {files.map((file) => (
        <div key={file.id}>
          <a href={file.url} target="_blank" rel="noreferrer">
            {file.name}
          </a>
        </div>
      ))}
    </Flex>
  );
};
